import { ModalConfirm } from 'mailup-web-components'
import PropTypes from 'prop-types'

import { useIntl } from 'react-intl'

const ModalWelcomeReactivation = ({ show, onCancel, onConfirm }) => {
  const intl = useIntl()

  return (
    <ModalConfirm
      show={show}
      title={intl.formatMessage({
        id: 'Load.WelcomeSeries.ModalReactivationWorkflowTitle'
      })}
      message={intl.formatMessage({
        id: 'Load.WelcomeSeries.ModalReactivationWorkflowDescr'
      })}
      onClickConfirm={onConfirm}
      onClickCancel={onCancel}
      stringConfirm={intl.formatMessage({
        id: 'Load.WelcomeSeries.ModalReactivationWorkflowConfirm'
      })}
      stringCancel={intl.formatMessage({ id: 'Load.Common.Close' })}
    />
  )
}

ModalWelcomeReactivation.propTypes = {
  show: PropTypes.bool,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func
}

export default ModalWelcomeReactivation
